import React, { useEffect, useState } from 'react';
import { useForm, SubmitHandler, Controller, useFieldArray } from 'react-hook-form';
import Input from '../../../../components/elements/form/input';
import Teaxtarea from '../../../../components/elements/form/textarea';
import SelectBox from '../../../../components/elements/form/selectBox';
import Button from '../../../../components/elements/button';
import { useAppLoader } from '../../../../_common/pageLoader/appLoaderHook';
import { useStockAdjustmentApi } from '../../../../store/api/hooks/stockAdjustmentApiHook';
import { useFacilitiesApi } from '../../../../store/api/hooks/facilitiesApiHook';
import toast from 'react-hot-toast';
import { getSelectedOption, localDate, showDate } from '../../../../_common/functions';
import moment from 'moment';
import { DATE_FORMAT, DATE_TIME_FORMAT } from '../../../../_common/constant';
import { useAssetsApi } from '../../../../store/api/hooks/assetsApiHook';
import { useSpearPartsApi } from '../../../../store/api/hooks/spearPartsApiHook';
import { useUserSelector } from '../../../../store/selectors/userSelector';
import { useCycleCountApi } from '../../../../store/api/hooks/cycleCountApiHook';
import Datepicker from '../../../../components/elements/form/datepicker';


interface StockAdjFormProps {
    _ref?: any;
    editID?: any;
    onCreate?: () => void
    onCancel?: () => void
    partDetails?: any
}

type partType = {
    id?: number;
    partDetails?: any;
    partCode?: string;
    partName?: string;
    stockOnHand?: number;
    qty?: any;
    cost?: number;
    part?: any
}

type FormValues = {
    stockAdjustmentID?: number;
    stockAdjustmentSerialNo: string;
    stockAdjustmentDate: any;

    operatorID: any;
    facilityID: any;
    subFacilityID: any;
    stockAdjustmentNote: string;
    adjustmentDetailsList: any[];
    parts: partType[];
};

const CreateStockAdjustment: React.FC<StockAdjFormProps> = ({ _ref, editID, onCreate = () => { }, onCancel = () => { }, partDetails }) => {
    const { control, register, handleSubmit, formState: { errors }, reset, trigger, setValue, watch } = useForm<FormValues>();
    const stockAPI = useStockAdjustmentApi();
    const spearPartsAPI = useSpearPartsApi();
    const facilityApi: any = useFacilitiesApi();
    const assetApi: any = useAssetsApi();
    const { showLoader, hideLoader } = useAppLoader();
    const [facilityoption, setFacilityoption] = useState<any>(null);
    const [subFacilityOptions, setSubFacilityOptions] = useState<any>([]);
    const [vendorlist, setvendorList] = useState<any>([]);
    const [editData, setEditData] = useState<any>(null);
    const [disabledFacility, setDisabledFacility] = useState<boolean>(false);
    const cycleCountAPI = useCycleCountApi();
    const user: any = useUserSelector();
    const [scanCode, setScanCode] = useState<string>('');
    const [parts, setParts] = useState<any>([]);
    const [partstatus, setPartStatus] = useState<boolean>(false);
    const facilityWatch = watch('facilityID');
    const subFacilityWatch = watch('subFacilityID');

    // const { fields: parts, append, update, prepend, remove, swap, move, insert } = useFieldArray({
    //     control, // control props comes from useForm (optional: if you are using FormContext)
    //     name: "parts", // unique name for your Field Array
    // });

    const partsWatch: any = watch('parts');

    const getNewCode = () => {
        stockAPI.getStockAdjustmentCode({},
            (resp: any) => {
                console.log("New Code", resp)
            }, (error: any) => {
                console.log("New Code Error", error)
            }
        )
    }

    const getfacilitylist = () => {
        const payload = {
            pageSize: 100,
            pageNumber: 1,
        };
        facilityApi.getFacilityList(
            payload,
            (resp: any) => {
                let facilitylist: any = resp.facilityList.map((facilist: any) => {
                    return {
                        label: facilist.facilityName,
                        value: facilist.facilityID,
                    };
                });
                setFacilityoption(facilitylist);
            },
            (error: any) => {
                console.log("error =>", error);
                toast.error(error);
            }
        );
    };

    const getVenderList = () => {
        const payload = {};
        assetApi.GetvenderList(
            payload,
            (resp: any) => {
                let deptlist: any = resp.vendorList.map((facilist: any) => {
                    return {
                        label: facilist.name,
                        value: facilist.vendorID,
                    }
                });
                setvendorList(deptlist);
            },
            (error: any) => {
                console.log("error =>", error);
                toast.error(error);
            }
        );
    };


    const onSubmit: SubmitHandler<FormValues> = data => {
        if (parts.length == 0) {
            toast.error("Please add at least one part");
            return;
        }
        console.log(data);
        let payload: any = {
            facilityID: data.facilityID.value,
            subFacilityID: null,//data.subFacilityID?.value,
            stockAdjustmentNote: data.stockAdjustmentNote,
            stockAdjustmentDate: data.stockAdjustmentDate ? moment(data.stockAdjustmentDate).format('YYYY-MM-DD') : null,
            operatorID: user.userID,
            // stockAdjustmentDate: showDate(new Date(), DATE_FORMAT),
            adjustmentDetailsList: parts.map((part: any) => {
                return {
                    "partsID": part.partDetails.partsID,
                    "stockOnHand": part.currentStock,
                    "adjustedQuantity": ((Number(part.in_stock ?? 0) + Number(part.currentStock ?? 0)) - Number(part.out_stock ?? 0)),
                    "partsCostRate": part.avgUnitCost ?? 0,
                    "partsTotalAmount": ((Number(part.in_stock ?? 0) + Number(part.currentStock ?? 0)) - Number(part.out_stock ?? 0)) * Number(part.avgUnitCost ?? 0),
                    "partsTotalAmountLocal": ((Number(part.in_stock ?? 0) + Number(part.currentStock ?? 0)) - Number(part.out_stock ?? 0)) * Number(part.avgUnitCost ?? 0),
                    "exchangeRate": 1,
                    "currencyID": 1,
                    "unitID": part.partDetails.unitID
                }
            })

        }

        if (editID) {
            payload['stockAdjustmentID'] = editID;
        }
        console.log("payload", payload);
        // return

        showLoader();
        stockAPI.saveStockAdjustment(payload, (resp: any) => {
            onCreate();
            onCancel();
            console.log(resp, "Submited resp")
            toast.success(resp?.message)
            formReset();
            hideLoader();

        }, (error: any) => {
            console.log('error =>', error);
            hideLoader();
            toast.error(error);
        });
    };

    const formReset = () => {
        if (!partDetails) {
            reset({

                stockAdjustmentSerialNo: "",
                stockAdjustmentDate: localDate(new Date(), DATE_FORMAT),
                operatorID: "",
                facilityID: "",
                stockAdjustmentNote: "",
                adjustmentDetailsList: [],
            });
            setPartStatus(false);
            setParts([]);

            setDisabledFacility(false);
        }

    }

    useEffect(() => {
        if (facilityWatch) {
            setValue('subFacilityID', null);
            const payload = {
                facilityID: facilityWatch.value
            }
            facilityApi.getSubFacilityList(
                payload,
                (resp: any) => {
                    setSubFacilityOptions(resp?.subFacilityList?.map((facilist: any) => {
                        return {
                            label: `${facilist.subFacilityTypeName} - ${facilist.no}`,
                            value: facilist.subFacilityID,
                        };
                    }));
                },
                (error: any) => {
                    console.log("error =>", error);
                    toast.error(error);
                }
            );
        }
    }, [facilityWatch]);

    useEffect(() => {
        //getNewCode();
        getfacilitylist();
        getVenderList();
    }, []);

    useEffect(() => {
        if (editID) {
            stockAPI.getStockAdjustmentByID({ PartsStockAdjustmentID: editID }, (resp: any) => {
                console.log("Edit Data", resp)
                setEditData(resp);
            }, (error: any) => {
                console.log("Edit Data Error", error)
            })
        }
    }, [editID]);

    useEffect(() => {
        console.log("Parts Watch", partsWatch)
    }, [partsWatch]);

    useEffect(() => {
        console.log(editData);
        if (editData == null) {
            formReset();
        }
    }, [editData]);

    useEffect(() => {
        if (editData) {
            reset({

                stockAdjustmentSerialNo: editData.stockAdjustmentSerialNo,
                stockAdjustmentDate: localDate(editData.stockAdjustmentDate),
                operatorID: getSelectedOption(editData.operatorID, vendorlist),
                facilityID: getSelectedOption(editData.facilityID, facilityoption ? facilityoption : []),
                subFacilityID: getSelectedOption(editData.subFacilityID, subFacilityOptions),
                stockAdjustmentNote: editData.stockAdjustmentNote,
                parts: editData?.stockAdjustmentList.map((part: any) => {
                    return {
                        partCode: part.partsCode,
                        partName: part.partName,
                        stockOnHand: part.stockOnHand,
                        qty: part.stockOnHand,
                        cost: part.partsTotalAmount,
                        partDetails: { ...part, sparePartsName: part.partName, currenctStock: part.stockOnHand, costPerUnit: part.partsCostRate, }
                    }
                }
                )
            });
        }
    }, [editData, facilityoption, vendorlist]);


    // useEffect(() => {
    //     if(partDetails){
    //     if(facilityWatch){
    //         let payload: any = {
    //             partID: partDetails.partsID,
    //             facilityID: facilityWatch.value
    //         }
    //         if(subFacilityWatch){
    //             payload['subFacilityID'] = subFacilityWatch.value;
    //         }

    //         cycleCountAPI.GetStockCount(payload, (resp: any) => {
    //             remove();
    //             append({
    //                 partCode: partDetails.partsCode,
    //                 partName: partDetails.partName,
    //                 stockOnHand: resp.currentStock || 0,
    //                 qty: resp.currentStock || 0,
    //                 cost: (resp.currentStock || 0) * partDetails.costPerUnit,
    //                 part: partDetails,
    //                 partDetails: partDetails
    //             })
    //         }, (error: any) => { });
    //     } 
    // }
    // }, [facilityWatch, subFacilityWatch,partDetails]);


    /* useEffect(() => {
        if (partDetails && facilityoption) {
            console.log('~~~~~~~~~~~~', facilityoption, getSelectedOption(partDetails.facilityID, facilityoption ? facilityoption : []))
            reset({
                facilityID: getSelectedOption(partDetails.facilityID, facilityoption ? facilityoption : []),
                //subFacilityID: getSelectedOption(editData.subFacilityID, subFacilityOptions),
                stockAdjustmentNote: '',
                parts: []
            });
            remove();
            cycleCountAPI.GetStockCount({ partID: partDetails.partsID, facilityID: partDetails.facilityID }, (resp: any) => {
                append({
                    partCode: partDetails.partsCode,
                    partName: partDetails.partName,
                    stockOnHand: resp.currentStock || 0,
                    qty: resp.currentStock || 0,
                    cost: (resp.currentStock || 0) * partDetails.costPerUnit,
                    part: partDetails,
                    partDetails: partDetails
                })
            },
                (error: any) => {

                }
            );
        }
    }, [partDetails, facilityoption]); */

    const addScanCode = (code: string) => {
        spearPartsAPI.getSpearPartsList(
            {
                pageSize: 20,
                pageNumber: 1,
                searchParam: code,
            },
            (data: any) => {
                if (data?.sparePartsList?.length > 0) {
                    let partOption = {
                        label: data?.sparePartsList[0].sparePartsName + ` (${data?.sparePartsList[0].partsCode})`,
                        value: data?.sparePartsList[0].partsID,
                        partDetails: data?.sparePartsList[0],
                    };

                    cycleCountAPI.GetStockCount(
                        {
                            partID: partOption.value,
                            facilityID: facilityWatch?.value,
                            subFacilityID: subFacilityWatch?.value
                        },
                        (resp: any) => {
                            let alreadyAdded = false;

                            setParts(parts.map((part: any) => {
                                if (part.partDetails?.partsCode == partOption.partDetails?.partsCode) {
                                    alreadyAdded = true
                                    return { ...part, qty: Number(part.qty) + 1 }
                                } else {
                                    return part
                                }
                            }))
                            if (!alreadyAdded) {
                                setParts([
                                    ...parts,
                                    {
                                        ...partOption,
                                        currentStock: resp?.currentStock || 0,
                                        avgUnitCost: resp?.avgUnitCost ?? 0,
                                        in_stock: 0,
                                        out_stock: 0,
                                        qty: 1
                                    },
                                ]);
                            }
                        },
                        (error: any) => {
                            setParts([...parts, { ...partOption, currentStock: 0, avgUnitCost: 0 }]);
                        }
                    );
                } else {
                    toast.error("No spare part found")
                }
            },
            (error: any) => {
                toast.error("No spare part found")
            }
        );
    }

    useEffect(() => {
        if (_ref?.current) {
            _ref.current.reset = formReset;
        }
    }, [_ref]);

    return (
        <form onSubmit={handleSubmit(onSubmit)} ref={_ref}>
            <div className='pt-4'>
                {
                    editData && <>
                        <div className="grid grid-cols-3 gap-2">
                            <div className='bg-green-50 py-2 px-3'>
                                <h6 className='text-[0.813rem] font-semibold'>Adjustment No</h6>
                                <p className='text-[0.813rem] font-normal mt-2'>{editData?.stockAdjustmentSerialNo}</p>
                            </div>
                            <div className='bg-green-50 py-2 px-3 '>
                                <h6 className='text-[0.813rem] font-semibold'>Adjusted By</h6>
                                <p className='text-[0.813rem] font-normal mt-2'>{editData?.addedByName}</p>
                            </div>
                            <div className='bg-green-50 py-2 px-3'>
                                <h6 className='text-[0.813rem] font-semibold'>Date and Time</h6>
                                <p className='text-[0.813rem] font-normal mt-2'>{showDate(editData?.stockAdjustmentDate, DATE_TIME_FORMAT)}</p>
                            </div>
                        </div>
                    </>
                }

                {/* <div className="grid grid-cols-2 gap-2"> */}
                <Controller
                    name='facilityID'
                    control={control}
                    rules={{ required: 'Facility is required' }}
                    render={({ field: { value, onChange } }) => (
                        <SelectBox
                            label='Select Facility'
                            value={value}
                            onChange={onChange}
                            disabled={disabledFacility}
                            required
                            placeholder='Choose Facility'
                            options={facilityoption ? facilityoption : []}
                            className='mb-0'
                            error={errors.facilityID?.message as any}
                        />
                    )}
                />
                {/* <Controller
                    name='subFacilityID'
                    control={control}
                    render={({ field: { value, onChange } }) => (
                        <SelectBox
                            label='Select Sub Facility'
                            value={value}
                            isClearable={true}
                            onChange={onChange}
                            disabled={disabledFacility}
                            placeholder='Choose Facility'
                            options={subFacilityOptions}
                            className='mb-0'
                        />
                    )}
                /> */}
                <Controller
                    name="stockAdjustmentDate"
                    control={control}
                    rules={{ required: 'Stock adjustment Date is required' }}
                    render={({ field: { value, onChange } }) => (
                        <Datepicker
                            label="Stock adjustment Date"
                            required
                            value={value}
                            onChange={onChange}
                            error={errors.stockAdjustmentDate?.message as any}
                        />
                    )}
                />
                {!editID && (
                    <Button disabled={partstatus} className="mt-3" type="button"
                        onClick={() => {
                            trigger(['facilityID']).then((valid: boolean) => {
                                if (valid) {
                                    setPartStatus(true);
                                    if (partDetails) {
                                        addScanCode(partDetails.partsCode)
                                    }
                                }
                            })
                        }}
                    >
                        Start
                    </Button>
                )}

                {partstatus && (
                    <>
                        {!partDetails && !editID && (
                            <div>
                                <Input
                                    className="!my-0"
                                    type="text"
                                    value={scanCode}
                                    onChange={(e: any) => {
                                        setScanCode(e.target.value)
                                    }}
                                    placeholder="Enter Part Code"
                                    onKeyDown={(e: any) => {
                                        if (e.key === "Enter") {
                                            e.preventDefault();
                                            if (e.target.value) {
                                                addScanCode(e.target.value);
                                                setScanCode('')
                                            }
                                        }
                                    }}
                                />
                                <div className="text-center mt-2 font-normal text-slate-500">OR</div>
                                <SelectBox
                                    className="mt-2"
                                    async={true}
                                    value={null}
                                    onChange={(option) => {
                                        console.log("fdsfsfsfsf", option);
                                        cycleCountAPI.GetStockCount(
                                            {
                                                partID: option.value,
                                                facilityID: facilityWatch?.value,
                                                subFacilityID: subFacilityWatch?.value
                                            },
                                            (resp: any) => {
                                                console.log("return arra--------", resp);
                                                //part?.partDetails?.partsCode

                                                let alreadyAdded = false;

                                                setParts(parts.map((part: any) => {
                                                    if (part.partDetails?.partsCode == option.partDetails?.partsCode) {
                                                        alreadyAdded = true;

                                                        return { ...part, qty: Number(part.qty) + 1 }
                                                    } else {
                                                        return part
                                                    }
                                                }))
                                                if (!alreadyAdded) {
                                                    setParts([
                                                        ...parts,
                                                        {
                                                            ...option,
                                                            currentStock: resp?.currentStock || 0,
                                                            avgUnitCost: resp?.avgUnitCost ?? 0,
                                                            qty: 1
                                                        },
                                                    ]);
                                                }
                                            },
                                            (error: any) => {
                                                setParts([...parts, { ...option, currentStock: 0, avgUnitCost: 0 }]);
                                            }
                                        );
                                    }}
                                    placeholder="search part here"
                                    asyncLoadOptions={(value: string) => {
                                        return new Promise((resolve, reject) => {
                                            spearPartsAPI.getSpearPartsList(
                                                {
                                                    pageSize: 20,
                                                    pageNumber: 1,
                                                    searchParam: value,
                                                },
                                                (data: any) => {
                                                    // console.log("Part Data", data)
                                                    resolve(
                                                        data.sparePartsList.map((part: any) => {
                                                            return {
                                                                label: part.sparePartsName + ` (${part.partsCode})`,
                                                                value: part.partsID,
                                                                partDetails: part,
                                                            };
                                                        })
                                                    );
                                                },
                                                (error: any) => {
                                                    reject(error);
                                                }
                                            );
                                        });
                                    }}
                                />
                            </div>
                        )}

                        <div className='flex justify-between items-center my-6'>
                            <h4 className='font-semibold text-[0.938rem] uppercase'>PART DETAILS</h4>

                        </div>

                        <div className="rounded-md border border-gray-300 mt-3">
                            <div className='grid grid-cols-12 gap-1 bg-gray-100'>
                                <div className='col-span-2 px-2 leading-10 '>
                                    <label className='text-[0.75rem] font-medium text-slate-600'>Part Code</label>
                                </div>
                                <div className='col-span-2 px-2 leading-10'>
                                    <label className='text-[0.75rem] font-medium text-slate-600'>Part Name</label>
                                </div>
                                <div className='col-span-2 px-2 leading-10'>
                                    <label className='text-[0.75rem] font-medium text-slate-600'>Stock on Hand</label>
                                </div>
                                <div className='col-span-2 px-2 leading-10'>
                                    <label className='text-[0.75rem] font-medium text-slate-600'>In Qty</label>
                                </div>
                                <div className='col-span-2 px-2 leading-10'>
                                    <label className='text-[0.75rem] font-medium text-slate-600'>Out Qty</label>
                                </div>
                                <div className='col-span-2 px-2 leading-10'>
                                    <label className='text-[0.75rem] font-medium text-slate-600'>Adjusted Cost</label>
                                </div>
                            </div>
                            {parts.map((part: any, index: any) => (
                                <div className='grid grid-cols-12 gap-1 text-slate-800' key={part.id}>
                                    <div className='col-span-2 px-2 leading-10 flex items-center'>

                                        <p className='font-medium text-[0.75rem]'>{part?.partDetails?.partsCode}</p>


                                    </div>
                                    <div className='col-span-2 px-2 leading-10 flex items-center'>
                                        <label className='text-[0.75rem] font-normal leading-[1.2]'>{part?.partDetails?.sparePartsName}</label>
                                    </div>
                                    <div className='col-span-2 px-2 leading-10 flex items-center'>
                                        <label className='text-[0.75rem] font-normal text-center w-full'>{part?.currentStock}</label>
                                    </div>
                                    <div className='col-span-2 px-2 leading-10 flex items-center'>
                                        <Input
                                            size="sm"
                                            className="!my-0"
                                            type="number"
                                            value={part.in_stock ?? 0}
                                            onChange={(e) => {
                                                const value = Number(e.target.value);
                                                if (value < 0) {
                                                    toast.error("Value cannot be negative");
                                                    return;
                                                }
                                                setParts(
                                                    parts.map((_part: any) => {
                                                        if (_part.value == part.value) {
                                                            _part.in_stock = e.target.value;
                                                        }
                                                        return _part;
                                                    })
                                                );


                                            }}
                                        />

                                    </div>
                                    <div className='col-span-2 px-2 leading-10 flex items-center'>
                                        <Input
                                            size="sm"
                                            className="!my-0"
                                            type="number"
                                            value={part.out_stock ?? 0}
                                            onChange={(e) => {
                                                const value = Number(e.target.value);
                                                if (value < 0) {
                                                    toast.error("Value cannot be negative");
                                                    return;
                                                }
                                                setParts(
                                                    parts.map((_part: any) => {
                                                        if (_part.value == part.value) {
                                                            _part.out_stock = e.target.value;
                                                        }
                                                        return _part;
                                                    })
                                                );


                                            }}
                                        />

                                    </div>
                                    <div className='col-span-2 px-2 leading-10 flex items-center'>
                                        <label className='text-[0.75rem] font-normal text-center w-full'>{(part?.in_stock || part?.out_stock) ? `$${((Number(part.in_stock ?? 0) - Number(part?.out_stock ?? 0)) * Number(part?.avgUnitCost ?? 0)).toFixed(2)}` : '-'}</label>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </>
                )}

                <Controller
                    name='stockAdjustmentNote'
                    control={control}
                    render={({ field: { value, onChange } }) => (
                        <Teaxtarea
                            label='Notes'
                            value={value}
                            onChange={onChange}
                            placeholder='Write Your Notes'
                        />
                    )}
                />

                <hr className='border-gray-900 my-6' />
            </div>
            <div className='flex justify-end gap-2'>
                <Button type='submit' disabled={parts.length == 0 ? true : false}>Save</Button>
                <Button theme='secondary' onClick={() => {
                    onCancel();
                    formReset();
                }}>Cancel</Button>
            </div>
        </form>
    );
};

export default CreateStockAdjustment;